import React from 'react';
import { Loader2 } from 'lucide-react';

/**
 * UploadProgressOverlay — fullscreen-of-parent overlay shown while a pose
 * video is being uploaded. Receives `{ progress: 0-100, name, size }`.
 */
export default function UploadProgressOverlay({ info, poseId }) {
  if (!info) return null;
  const pct = Math.max(0, Math.min(100, Math.round(info.progress || 0)));
  const sizeMb = info.size ? (info.size / 1024 / 1024).toFixed(1) : null;

  return (
    <div
      className="absolute inset-0 z-40 flex flex-col items-center justify-center bg-black/85 backdrop-blur-sm rounded-xl gap-3 px-4"
      data-testid={`pose-upload-progress-${poseId}`}
    >
      <Loader2 className="w-7 h-7 text-amber-400 animate-spin" />
      <div className="text-center">
        <p className="text-amber-200 text-xs font-medium">Envoi en cours…</p>
        {sizeMb && (
          <p className="text-white/60 text-[10px] mt-0.5">{info.name} — {sizeMb} Mo</p>
        )}
      </div>
      <div className="w-full max-w-[200px] h-2 rounded-full bg-white/10 overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-amber-400 to-amber-500 transition-all duration-200"
          style={{ width: `${pct}%` }}
          data-testid={`pose-upload-bar-${poseId}`}
        />
      </div>
      <p className="text-amber-300 font-mono text-sm font-semibold">{pct}%</p>
      <p className="text-white/40 text-[9px] text-center max-w-[220px]">
        Ne fermez pas l'application pendant l'envoi.
      </p>
    </div>
  );
}
